import { apiClient } from '../../gateways/api'
import type { FetchProjectSelectlists } from '../types/FetchProjectSelectlists'

export { fetchProjectSelectlists, initialState }

const initialState: FetchProjectSelectlists = {
  data: {
    labels: [],
  },
}

const fetchProjectSelectlists = async ({
  id,
}: {
  id: string
}): Promise<FetchProjectSelectlists['data']> => {
  const { data } = await apiClient({
    url: `/rest/project/${id}/selectlists`,
    method: 'GET',
  })

  return data
}
